import React, { createContext, useContext } from "react";
import { useLanguage } from "../../Language";
import { ConfirmDialog } from "@tlc/ui/dialog/ConfirmDialog";
import { useDialog } from "@tlc/ui/dialog/useDialog";
import { Alert } from "@mui/material";

interface SimpleErrorDialogContextType {
  showSimpleErrorDialog: (message: string) => void;
}

const SimpleErrorDialogContext = createContext<
  SimpleErrorDialogContextType | undefined
>(undefined);

export const useSimpleErrorDialog = () => {
  const ctx = useContext(SimpleErrorDialogContext);
  if (!ctx)
    throw new Error(
      "useSimpleErrorDialog must be used within SimpleErrorDialogProvider",
    );
  return ctx;
};

export const SimpleErrorDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { translate } = useLanguage();

  const [message, setMessage] = React.useState("");
  const { openDialog, dialogProps } = useDialog();

  const showSimpleErrorDialog = (msg: string) => {
    setMessage(msg);
    openDialog();
  };

  return (
    <SimpleErrorDialogContext.Provider value={{ showSimpleErrorDialog }}>
      {children}
      <ConfirmDialog
        id="simple-error-dialog"
        useSingleAction
        confirmButtonText={translate("ok")}
        headline={translate("errorDialogTitle")}
        onConfirm={dialogProps.onClose}
        {...dialogProps}
      >
        <Alert severity="error">{message}</Alert>
      </ConfirmDialog>
    </SimpleErrorDialogContext.Provider>
  );
};
